import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './components/ui/toast';
import './styles/globals.css';

/**
 * Main Application Component
 * Wraps the app with necessary providers
 */
function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
